const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const areaCodeImageMapping = {
      "A": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bayern.png?v=1716625754",
      "AA": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/baden-wuerttemberg.png?v=1716625754",
      "AB": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bayern.png?v=1716625754",
      "ABG": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/thueringen.png?v=1716625754",
      "ABI": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen-anhalt.png?v=1716625755",
      "AC": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/nrw.png?v=1716625754",
      "AE": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen.png?v=1716625754",
      "AK": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/rheinland-pfalz.png?v=1716625755",
      "LH": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/nrw.png?v=1716625754",
      "AZE": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen-anhalt.png?v=1716625755",
      "HH": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/hamburg.png?v=1716625754",
      "HGN": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/mecklenburg-vorpommern.png?v=1716625754",
      "HEN": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/hessen.png?v=1716625754",
      "HI": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/niedersachsen.png?v=1716625754",
      "HB": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bremen.png?v=1716625754",
      //"B": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/berlin.png?v=1716625754",
      "ECK": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/schleswig-holstein.png?v=1716625754",
      "HOM": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/saarland.png?v=1716625754",
      "HVL": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/brandenburg.png?v=1716625754",
      "RE": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/nrw.png?v=1716625754",
      "L": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/sachsen.png?v=1716625754",
      // ... other mappings
      "N": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bayern.png?v=1716625754",
      "MA": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/baden-wuerttemberg.png?v=1716625754",
      "NAB": "https://cdn.shopify.com/s/files/1/0832/5693/4748/files/bayern.png?v=1716625754",
      // Add more mappings for other areas
    };

    const bayernCodes = [
      "A", "AB", "AIB", "AIC", "ALZ", "AM", "AN", "AÃ–", "AS", "BA", "BGD", "BGL", "BOG", "BRK", "BT", "BUL", "BYL", "CHA", "CO", "DAH", "DEG", "DGF",
      "DKB", "DLG", "DON", "EBE", "EBN", "EBS", "ED", "EG", "EI", "ER", "ERH", "ESB", "FDB", "FEU", "FFB", "FO", "FRG", "FS", "FÃœ", "FÃœS", "GAP",
      "GEO", "GRA", "GRI", "GUN", "GZ", "HAB", "HAS", "HEB", "HIP", "HO", "HOH", "HÃ–S", "ILL", "IN", "KC", "KE", "KEH", "KEM", "KF", "KG", "KÃ–N",
      "KÃ–Z", "KRU", "KT", "KU", "PA", "PAF", "PAN", "PAR", "PEG", "OA", "OAL", "OBB", "OCH", "OVI", "N", "NAB", "NAI", "ND", "NEA", "NEC", "NEN",
      "NES", "NEW", "NM", "NÃ–", "NU", "R", "REG", "REH", "REI", "RH", "RID", "RO", "ROD", "ROL", "ROT", "SAD", "SAN", "SC", "SEF", "SEL", "SMÃœ",
      "SOB", "SOG", "SR", "STA", "STE", "SUL", "SW", "TIR", "TÃ–L", "TS", "UFF", "VIB", "VIT", "VOH", "WEN", "WER", "WM", "WOR", "WOS", "WS", "WÃœ",
      "WUG", "WÃœM", "WUN", "M", "MAI", "MAK", "MAL", "MB", "MET", "MIL", "MM", "MN", "MOD", "MSP", "MÃœ", "MÃœB", "LA", "LAN", "LAU", "LF", "LI",
      "LIF", "LL"
    ];

    const badenWuerttembergCodes = [
      "AA", "BAD", "BB", "BC", "BCH", "BH", "BK", "BL", "BÃœS", "BWL", "CR", "CW", "EM", "ES", "FDS", "FN", "FR", "GD", "GP", "HCH", "HD", "HDH", "HN", 
      "HOR", "KA", "KEL", "KN", "KÃœN", "PF", "OG", "NEU", "NT", "RA", "RT", "RV", "RW", "S", "SÃ„K", "SHA", "SIG", "SLG", "STO", "TBB", "TT", "TÃœ", 
      "TUT", "UL", "VAI", "VS", "WG", "WN", "WOL", "WT", "MA", "MGH", "MOS", "MÃœL", "LB", "LEO", "LÃ–", "LR"
    ];

    const brandenburgCodes = [
      "ANG", "BAR", "BBL", "BER", "BRB", "BSK", "CA", "CB", "EE", "EH", "EW", "FF", "FI", "FOR", "FRW", "FW", "GUB", "HVL", 
      "KW", "KY", "P", "PM", "PR", "PZ", "OHV", "OPR", "OSL", "NAU", "NP", "RN", "SDT", "SEE", "SFB", "SPB", "SPN", "SRB", 
      "TF", "TP", "UM", "WK", "MOL", "LC", "LDS", "LIB", "LN", "LOS"
    ];

    const hessenCodes = [
      "BID", "BÜD", "DA", "DI", "DIL", "ERB", "ESW", "F", "FB", "FD", "FKB", "FZ", "GG", "GI", "GN", "HEF", "HEL", "HG", 
      "HOG", "HP", "HR", "HU", "KB", "KS", "OF", "ROF", "RÜD", "SLÜ", "SWA", "USI", "VB", "WA", "WEL", "WI", "WIZ", 
      "WOH", "WZ", "ZIG", "MEG", "MKK", "MR", "MTK", "LDK", "LM"
    ];

    const mecklenburgVorpommernCodes = [
      "ANK", "AT", "BÜZ", "DBR", "DM", "GDB", "GMN", "GÜ", "GVM", "GW", "HGN", "HGW", "HRO", "HST", "HWI", "PCH", "PW", 
      "OVP", "NB", "NVP", "NWM", "NZ", "RDG", "RM", "ROS", "RÜG", "SBG", "SN", "STB", "TET", "UEM", "VG", "VR", "WIS", 
      "WLG", "WRN", "MC", "MSE", "MST", "MÜR", "MVL", "LBZ", "LRO", "LUP"
    ];

    const niedersachsenCodes = [
      "ALF", "AUR", "BRA", "BRL", "BRV", "BS", "BSB", "CE", "CLP", "CLZ", "CUX", "DAN", "DEL", "DH", "DUD", "EIN", "EL", 
      "EMD", "FRI", "GAN", "GF", "GÖ", "GS", "H", "HE", "HI", "HK", "HM", "HMÜ", "HOL", "PE", "OHA", "OHZ", "OL", "OS", 
      "NI", "NL", "NOH", "NOM", "NOR", "RI", "ROW", "SHG", "STD", "SY", "SZ", "UE", "VEC", "VER", "WF", "WHV", "WL", 
      "WOB", "WST", "WTL", "WTM", "MEL", "LER", "LG", "LWL"
    ];

    const nordrheinWestfalenCodes = [
      "AC", "AH", "BE", "BF", "BI", "BLB", "BM", "BN", "BO", "BOH", "BOR", "BOT", "BÜR", "CAS", "COE", "D", "DIN", "DN", 
      "DO", "DU", "E", "EN", "ERK", "EU", "GE", "GEL", "GK", "GL", "GLA", "GM", "GT", "GV", "HA", "HAM", "HER", "HF", 
      "HS", "HSK", "HX", "JÜL", "K", "KK", "KLE", "KR", "PB", "OB", "OE", "OP", "NE", "NRW", "RE", "RS", "SG", "SI", 
      "SLE", "SO", "ST", "SU", "TE", "UN", "VIE", "W", "WAF", "WAN", "WAR", "WAT", "WES", "WIT", "ME", "MG", "MH", 
      "MI", "MK", "MO", "MON", "MS", "LEV", "LH", "LIP", "LP", "LÜN"
    ];


    const rheinlandPfalzCodes = [
      "AK", "AW", "AZ", "BIN", "BIR", "BIT", "BKS", "COC", "DAU", "DIZ", "DÜW", "EMS", "FT", "GER", "GOA", "GOH", "KH", 
      "KIB", "KL", "KO", "KUS", "PRÜ", "PS", "NR", "NW", "ROK", "RP", "RPL", "SAB", "SIM", "SP", "SÜW", "TR", "WIL", 
      "WO", "WW", "ZEL", "ZW", "MY", "MYK", "MZ", "LD", "LU"
    ];

    const saarlandCodes = [
      "HOM", "IGB", "OTW", "NK", "SAL", "SB", "SLS", "VK", "WND", "MZG"
    ];

    const sachsenCodes = [
      "AE", "ANA", "ASZ", "AU", "BED", "BIW", "BNA", "BZ", "C", "DD", "DL", "DW", "DZ", "EB", "ERZ", "FG", "FLÖ", "FTL", 
      "GC", "GHA", "GR", "GRH", "GRM", "HC", "HOT", "HY", "KM", "PIR", "PL", "OVL", "OZ", "NOL", "NY", "RC", "RG", "RIE", 
      "RL", "SEB", "STL", "SZB", "TDO", "TG", "TO", "V", "WDA", "WSW", "WUR", "Z", "ZI", "ZP", "MAB", "MEI", "MEK", 
      "MTL", "MW", "L", "LÖB", "LSN", "LSZ"
    ];

    const sachsenAnhaltCodes = [
      "ABI", "ASL", "AZE", "BBG", "BLK", "BÖ", "BRG", "BTF", "DE", "EIL", "GA", "GHC", "GNT", "HAL", "HBS", "HDL", 
      "HET", "HHM", "HV", "HZ", "JE", "JL", "KLZ", "KÖT", "OBG", "OC", "OK", "NEB", "NMB", "QFT", "QLB", "RSL", 
      "SAW", "SBK", "SDL", "SFT", "SGH", "SK", "SLK", "WB", "WMS", "WR", "WSF", "WZL", "ZE", "ZZ", "MD", "MER", 
      "ML", "MQ", "MSH", "LSA"
    ];

    const schleswigHolsteinCodes = [
      "ECK", "FL", "HEI", "HL", "IZ", "KI", "PI", "PLÖ", "OD", "OH", "NF", "NMS", "RD", "RZ", "SE", "SH", "SL", "MED"
    ];

    const thuringenCodes = [
      "ABG", "AP", "APD", "ARN", "ART", "EA", "EF", "EIC", "EIS", "G", "GRZ", "GTH", "HBN", "HIG", "IK", "IL", "J", 
      "KYF", "PN", "NDH", "NH", "RU", "SCZ", "SDH", "SHK", "SHL", "SLF", "SLN", "SLZ", "SM", "SOK", "SÖM", "SON", 
      "SRO", "THL", "UH", "WAK", "WBS", "WE", "ZR", "MGN", "MHL", "LBS"
    ];